export default "__VITE_ASSET__COlNmBhN__"